import { render, staticRenderFns } from "./BusinessDashboard.vue?vue&type=template&id=68921e1e"
import script from "./BusinessDashboard.vue?vue&type=script&lang=js"
export * from "./BusinessDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68921e1e')) {
      api.createRecord('68921e1e', component.options)
    } else {
      api.reload('68921e1e', component.options)
    }
    module.hot.accept("./BusinessDashboard.vue?vue&type=template&id=68921e1e", function () {
      api.rerender('68921e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/BusinessDashboard.vue"
export default component.exports